import { tvModeActive } from '@classes/app_url_params'
import { ADMIN_ROUTES, ROUTES } from '@constants/app_routes'
import { adminPrefix } from '@utils/navigation_utils'

import { adminTripRoutes } from './routes_definitions'

const pagesWithoutDashboardInTvMode = [ROUTES.INFO]

const pagesWithoutDashboard = [
  adminPrefix(ADMIN_ROUTES.ADMIN_GALLERY_VIEW),
  adminPrefix(ADMIN_ROUTES.ADMIN_MODBUS_ADDRESS),
  adminPrefix(ADMIN_ROUTES.ADMIN_MODBUS_CONFIG),
  adminPrefix(ADMIN_ROUTES.ADMIN_PAGES_CONFIG),
  adminPrefix(ADMIN_ROUTES.ADMIN_SETTINGS),
  adminPrefix(ADMIN_ROUTES.ADMIN_TRANSLATIONS),
  adminPrefix(ADMIN_ROUTES.ADMIN_NOTIFICATION),
  adminPrefix(ADMIN_ROUTES.ADMIN_IMAGE_UPLOAD),
  adminPrefix(ADMIN_ROUTES.ADMIN_WIDGET),
  adminPrefix(ADMIN_ROUTES.ADMIN_WIDGET_LAYOUT),
  adminPrefix(ADMIN_ROUTES.ADMIN_AGENDA),
  adminPrefix(ADMIN_ROUTES.ADMIN_GAUGE_LAYOUT),
  adminPrefix(ADMIN_ROUTES.ADMIN_API),
  adminPrefix(ADMIN_ROUTES.ADMIN_CREW),
  adminPrefix(ADMIN_ROUTES.ADMIN_FOOD_MANAGEMENT),
  adminPrefix(ADMIN_ROUTES.ADMIN_GALLERY),
  adminPrefix(ADMIN_ROUTES.ADMIN_ERRORS),
  adminPrefix(ADMIN_ROUTES.ADMIN_LIVE_LOG_VIEWER),
  adminPrefix(ADMIN_ROUTES.ADMIN_MODBUS_ADDRESS),
  adminPrefix(ADMIN_ROUTES.ADMIN_MODBUS_CONFIG),
  adminPrefix(ADMIN_ROUTES.ADMIN_YACHT_GALLERY_VIEW),
  adminPrefix(ADMIN_ROUTES.ADMIN_PAGES_CONFIG),
  adminPrefix(ADMIN_ROUTES.ADMIN_SETTINGS),
  adminPrefix(ADMIN_ROUTES.ADMIN_TRANSLATIONS),
  adminPrefix(ADMIN_ROUTES.ADMIN_TVMODE_3D),
  ROUTES.HOME,
  ROUTES.INFO,
  ROUTES.PDF
].concat(adminTripRoutes)

const pagesWithDashboard = new Set([
  ROUTES.SPEED_DISTANCE,
  ROUTES.WEATHER,
  ROUTES.WIND,
  ROUTES.TIMES,
  ROUTES.DISTANCE,
  ROUTES.BAROMETRIC_PRESSURE,
  ROUTES.DEPTH,
  ROUTES.TEMPERATURES,
  ROUTES.CALENDAR,
  ROUTES.CREW,
  ROUTES.TRIP,
  ROUTES.ECO_SCORE
])

const pagesWithScrollableBody = new Set([
  ROUTES.ADMIN,
  '/times',
  ROUTES.WEATHER,
  ROUTES.INFO_CHANNEL,
  ROUTES.HOME,
  ROUTES.YACHT_PAGE
])

const pagesWithOvalDashboard = new Set([ROUTES.THREE_D, ROUTES.TIMES, ROUTES.MAP])

export function shouldClearScrollLocks (pathname: string) {
  return pagesWithScrollableBody.has(pathname)
}

export function hasDashboard (pathname: ROUTES) {
  return pagesWithDashboard.has(pathname)
}

export function shouldShowDashboard (pathname: ROUTES) {
  return (
    (tvModeActive() && !pagesWithoutDashboardInTvMode.includes(pathname))
    || (hasDashboard(pathname) && !pagesWithoutDashboard.includes(pathname))
  )
}

export function hasOvalDashboard (pathname: ROUTES) {
  return pagesWithOvalDashboard.has(pathname)
}
